import debounce from 'lodash.debounce';
import { useEffect } from 'react';
const updatePopoverPosition = ({ ref, triggerRef, alignment, withTip, placement }) => {
    const popover = ref.current;
    const trigger = triggerRef.current;
    if (!popover || !trigger)
        return;
    const root = document.documentElement;
    const pM = parseInt(window.getComputedStyle(root).getPropertyValue('--page-margin'));
    popover.style.left = '';
    popover.style.width = '';
    popover.style.right = '';
    const triggerRect = trigger.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const windowInnerWidth = window.innerWidth;
    const triggerLeft = Math.round(triggerRect.left);
    const triggerRight = Math.round(triggerRect.right);
    const triggerWidth = Math.round(triggerRect.width);
    const popoverWidth = Math.round(popoverRect.width);
    const tipWidth = 20;
    let leftPosition = triggerLeft;
    let rightPosition = windowInnerWidth - triggerRight;
    const tipTriggerAlignValue = triggerWidth / 2 - tipWidth / 2;
    const getTipCentered = (tipLeft) => tipLeft + tipTriggerAlignValue;
    const popoverOffset = windowInnerWidth - popoverWidth - pM;
    if (placement === 'top') {
        popover.style.top = `${triggerRect.top - 20 - popoverRect.height}px`;
        const tipTop = popoverRect.height;
        popover.style.setProperty('--tip-top', `${tipTop}px`);
    }
    else {
        popover.style.top = `${triggerRect.bottom + 20}px`;
        const tipTop = -10;
        popover.style.setProperty('--tip-top', `${tipTop}px`);
    }
    if (windowInnerWidth < 768) {
        popover.style.left = `${pM}px`;
        popover.style.right = `${pM}px`;
        const tipLeft = triggerLeft - pM;
        popover.style.setProperty('--tip-left', `${getTipCentered(tipLeft)}px`);
        return;
    }
    switch (alignment) {
        case 'left': {
            leftPosition = triggerLeft;
            if (leftPosition + popoverWidth > windowInnerWidth - pM) {
                leftPosition = popoverOffset;
            }
            if (leftPosition < pM) {
                leftPosition = pM;
            }
            popover.style.left = `${leftPosition}px`;
            if (withTip) {
                const tipLeft = triggerLeft - leftPosition + tipTriggerAlignValue;
                popover.style.setProperty('--tip-left', `${tipLeft}px`);
            }
            break;
        }
        case 'right': {
            rightPosition = windowInnerWidth - triggerRight;
            if (rightPosition + popoverWidth > windowInnerWidth - pM) {
                rightPosition = popoverOffset;
            }
            if (rightPosition < pM) {
                rightPosition = pM;
            }
            popover.style.right = `${rightPosition}px`;
            if (withTip) {
                const tipRight = windowInnerWidth -
                    (rightPosition + triggerRight) +
                    tipTriggerAlignValue;
                popover.style.setProperty('--tip-left', 'unset');
                popover.style.setProperty('--tip-right', `${tipRight}px`);
            }
            break;
        }
        case 'center': {
            let leftPosForCenteredPopover = triggerLeft + triggerWidth / 2 - popoverWidth / 2;
            if (leftPosForCenteredPopover + popoverWidth > windowInnerWidth - pM) {
                leftPosForCenteredPopover = popoverOffset;
            }
            if (leftPosForCenteredPopover < pM) {
                leftPosForCenteredPopover = pM;
            }
            popover.style.left = `${leftPosForCenteredPopover}px`;
            if (withTip) {
                const tipLeft = triggerLeft - leftPosForCenteredPopover;
                popover.style.setProperty('--tip-left', `${getTipCentered(tipLeft)}px`);
            }
            break;
        }
    }
};
export const usePopoverPosition = ({ ref, triggerRef, alignment, placement, open, withTip }) => {
    useEffect(() => {
        document.fonts.onloadingdone = () => {
            updatePopoverPosition({
                ref,
                triggerRef,
                alignment,
                placement,
                withTip
            });
        };
    }, []);
    useEffect(() => {
        const debouncedUpdatePopoverPosition = debounce(updatePopoverPosition, 80);
        updatePopoverPosition({
            triggerRef,
            alignment,
            placement,
            ref,
            withTip
        });
        const handleResize = () => {
            debouncedUpdatePopoverPosition({
                ref,
                triggerRef,
                alignment,
                placement,
                withTip
            });
        };
        window.addEventListener('resize', handleResize, { passive: true });
        return () => {
            window.removeEventListener('resize', handleResize);
            debouncedUpdatePopoverPosition.cancel();
        };
    }, [ref, alignment, placement, open]);
};
//# sourceMappingURL=use-popover-position.js.map